import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background-color: #2089AC;
  color: white;
  text-align: center;
  padding: 20px;
  margin-top: 50px;
`;

const Footer = () => {
  return (
    <FooterContainer>
      <p>&copy; 2025 LES MINES D'AMEZMIZ. Tous droits réservés.</p>
    </FooterContainer>
  );
};

export default Footer;